<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

/**
 * Two-column section (e.g. "why us" + "enrollment period"). Each column has
 * an optional title and rich HTML body. HTML is sanitized server-side at
 * save time, so it is safe to SSR with v-html.
 */
defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()
</script>

<template>
  <div class="grid gap-8 md:grid-cols-2">
    <div v-if="data.left_title || data.left_html">
      <h3
        v-if="data.left_title"
        class="site-display mb-3 text-xl tracking-tight sm:text-2xl"
      >
        {{ data.left_title }}
      </h3>
      <div
        v-if="data.left_html"
        class="site-prose leading-relaxed [&_a]:underline [&_p]:my-2 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-6 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-6"
        v-html="data.left_html"
      />
    </div>
    <div v-if="data.right_title || data.right_html">
      <h3
        v-if="data.right_title"
        class="site-display mb-3 text-xl tracking-tight sm:text-2xl"
      >
        {{ data.right_title }}
      </h3>
      <div
        v-if="data.right_html"
        class="site-prose leading-relaxed [&_a]:underline [&_p]:my-2 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-6 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-6"
        v-html="data.right_html"
      />
    </div>
  </div>
</template>
